import axios from "axios";

export const rcApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/rythmes` });
rcApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("rc_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
rcApi.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 401) localStorage.removeItem("rc_token");
  return Promise.reject(err);
});

// Charte propre au projet (bleu nuit · doré · corail · turquoise) — n'affecte pas le reste de DOJOVA.
export const RC = {
  bg: "#0b1220", card: "#121c31", line: "#24324f", gold: "#d4af37", coral: "#ff6b6b", turquoise: "#2ec4b6", cream: "#f3efe6", muted: "#9aa6bf",
};

export const ytThumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
export const toSeconds = (t) => { const [m, s] = String(t).split(":").map(Number); return (m || 0) * 60 + (s || 0); };
export const ytUrl = (id, t) => `https://www.youtube.com/watch?v=${id}${t ? `&t=${toSeconds(t)}s` : ""}`;
export const ytIdFromUrl = (v) => { const m = String(v || "").match(/(?:v=|youtu\.be\/|shorts\/|embed\/)([A-Za-z0-9_-]{11})/); return m ? m[1] : String(v || "").trim(); };
export const spotifyEmbed = (url) => {
  const m = String(url || "").match(/open\.spotify\.com\/(?:intl-[a-z]{2}\/)?(track|album|playlist|artist)\/([A-Za-z0-9]+)/);
  return m ? `https://open.spotify.com/embed/${m[1]}/${m[2]}?theme=0` : null;
};
export const errMsg = (e, fallback = "Erreur") => e?.response?.data?.detail || e?.message || fallback;
